import api from './api';
import axios from 'axios';

export const getRiders = async () => {
  try {
    const { data } = await api.get("/users");   // existing full user data (used elsewhere)
    // keep only role === 'user'
    return data.filter((u) => u.role === "user");
  } catch (err) {
    console.error("Error fetching riders:", err);
    throw err;
  }
};

export const getRidersBasic = async () => {
  try {
    const { data } = await api.get("/riders/basic");
    // data already limited to user_id and name by backend
    return data;
  } catch (err) {
    console.error("Error fetching basic riders:", err);
    throw err;
  }
};


export const getRentals = async () => {
  try {
    const response = await api.get('/rentals');
    return response.data;
  } catch (error) {
    console.error('Error fetching rentals:', error);
    throw error;
  }
};

export const getScooters = async () => {
  const response = await api.get(`/scooters`);
  return response.data;
};

export const createRental = async (rentalData) => {
  try {
    const response = await api.post('/rentals', rentalData);
    return response.data;
  } catch (error) {
    console.error('Error creating rental:', error);
    throw error;
  }
};

export const updateRental = async (rentalId, updateData) => {
  try {
    const response = await api.put(`/rentals/${rentalId}`, updateData);
    return response.data;
  } catch (error) {
    console.error('Error updating rental:', error);
    throw error;
  }
};

export const deleteRental = async (rentalId) => {
  try {
    const response = await api.delete(`/rentals/${rentalId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting rental:', error);
    throw error;
  }
};

export const checkExpiringRentals = async () => {
  try {
    const response = await api.get('/rentals/check-expiring');
    return response.data;
  } catch (error) {
    console.error('Error checking expiring rentals:', error);
    throw error;
  }
};

export const updateScooter = async (id, scooterData) => {
  const response = await api.put(`/scooters/${id}`, scooterData);
  return response.data;
};

export const createScooter = async (scooterData) => {
  const response = await api.post(`/scooters`, scooterData);
  return response.data;
};

export const deleteScooter = async (id) => {
  const response = await api.delete(`/scooters/${id}`);
  return response.data;
};

// Ticket Management
// Fetch all tickets
export const getTickets = async () => {
  try {
    const response = await api.get('/tickets');
    return response.data;
  } catch (error) {
    console.error('Error fetching tickets:', error);
    throw error;
  }
};

// Create a new ticket
export const createTicket = async (ticketData) => {
  try {
    const response = await api.post('/tickets', ticketData);
    return response.data;
  } catch (error) {
    console.error('Error creating ticket:', error);
    throw error;
  }
};

// Update a ticket (reply or status)
export const updateTicket = async (ticketId, updateData) => {
  try {
    const response = await api.put(`/tickets/${ticketId}`, updateData);
    return response.data;
  } catch (error) {
    console.error('Error updating ticket:', error);
    throw error;
  }
};

// Fetch a single ticket by ID
export const getTicket = async (ticketId) => {
  try {
    const response = await api.get(`/tickets/${ticketId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching ticket:', error);
    throw error;
  }
};